module.exports = __webpack_public_path__ + "static/media/burn.2e8eb9f4.svg";